import React from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

interface GroupProtectedRouteProps {
  children: React.ReactNode;
}

const GroupProtectedRoute: React.FC<GroupProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();
  const location = useLocation();

  // Show loading during initial auth check
  if (isLoading) {
    return (
      <div className="loading-container">
        <div className="loading-spinner">
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  // Redirect to login if not authenticated
  if (!isAuthenticated) {
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  // AuthContext now handles all group routing logic
  // If we reach this point, the user is authenticated and routing is handled centrally
  return <>{children}</>;
};

export default GroupProtectedRoute;